export const getSpreadNameAsync = (
	definition:
		| Pick<eXpress.core.IDefinition, "hasCoverPage" | "pagesPerSpread">
		| null
		| undefined,
	spread: eXpress.core.Spread | undefined,
	currentSpreadNumber: number,
	totalSpreads: number,
	deps: {
		getLocalizedMonthNames: () => string[];
		localizedContent: eXpress.creator.LocalizedContent;
	},
) => {
	if (!spread || !definition) {
		return Promise.resolve("");
	}
	const isProductWithCover = definition?.hasCoverPage;
	const isMultiPage = definition?.pagesPerSpread && definition?.pagesPerSpread > 1;
	switch (spread.kind) {
		// Only get left page name (folded cards, ..) or right page name (photobooks, ..)
		case eXpress.core.SpreadKind.First:
		case eXpress.core.SpreadKind.Cover:
		case eXpress.core.SpreadKind.Last: {
			const page = spread.pageZones.first();
			return eXpress.creator
				.getPageNameAsync(spread, page, deps, true)
				.then(
					(pageName) =>
						pageName ||
						(isMultiPage
							? `${spread.pageNumbers.first()?.toString()}`
							: `${currentSpreadNumber} / ${totalSpreads}`) ||
						(isProductWithCover
							? `${currentSpreadNumber - 1}`
							: `${currentSpreadNumber} / ${totalSpreads}`),
				);
		}

		// Get both page names (update togheter)
		case eXpress.core.SpreadKind.Other: {
			const { pageNumbers } = spread;
			const leftPageName = eXpress.creator.getPageNameAsync(
				spread,
				spread.leftPage || undefined,
				deps,
				true,
			);
			const rightPageName = eXpress.creator.getPageNameAsync(
				spread,
				spread.rightPage || undefined,
				deps,
				true,
			);
			return Promise.all([leftPageName, rightPageName]).then(
				([pageNameLeft, pageNameRight]) => {
					let pageName = "";
					if (pageNameLeft && pageNameRight) {
						pageName += `${pageNameLeft} + ${pageNameRight}`;
					} else if (pageNameLeft) {
						pageName = pageNameLeft;
					} else if (pageNameRight) {
						pageName = pageNameRight;
					} else if (isMultiPage && pageNumbers.length === 2) {
						pageName = `${pageNumbers[0]}  -  ${pageNumbers[1]}`;
					} else {
						pageName = isProductWithCover
							? `${currentSpreadNumber - 1}`
							: `${currentSpreadNumber} / ${totalSpreads}`;
					}

					return pageName;
				},
			);
		}

		default: {
			return Promise.resolve("");
		}
	}
};
